"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollingTextLine = void 0;
const debounce_1 = require("../../utils/debounce");
const base_component_1 = require("../../components/base-component");
const utils_1 = require("../../utils/utils");
const ANNOUNCEMENT_SELECTOR = '[data-scrolling-text-line]';
const LINE_LINK_SELECTOR = '[data-scrolling-text-anchor]';
const ANIMATION_CLASS = 'scrolling-text--animated';
const FONT_MIXED_ATTRIBUTE = 'with-font-mixed';
const FONT_OUTLINE_CLASS = 'scrolling-text__text--font-outline';
class ScrollingTextLine extends base_component_1.BaseComponent {
    announcement;
    initialScreenWidth = 0;
    isWithFontMixed;
    screenSizeMultiply = 2;
    resizeObserver;
    constructor() {
        super();
        this.isWithFontMixed = this.hasAttribute(FONT_MIXED_ATTRIBUTE);
    }
    mountComponent() {
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(document.body);
    }
    unmountComponent() {
        this.resizeObserver.disconnect();
    }
    getDimentions = () => {
        const announcement = (0, utils_1.$el)(ANNOUNCEMENT_SELECTOR, this);
        if (!announcement) {
            return;
        }
        const screenWidth = document.body.clientWidth;
        const announcementWidth = announcement.clientWidth;
        this.initialScreenWidth = screenWidth;
        return { screenWidth, announcementWidth };
    };
    calcQuantityToRender = (screenWidth, announcementWidth) => {
        const blocksToRender = Math.ceil((screenWidth * this.screenSizeMultiply) / announcementWidth);
        return blocksToRender % 2 === 0 ? blocksToRender : blocksToRender + 1;
    };
    renderNodes = (blocksNumberToRender) => {
        if (!this.announcement) {
            this.announcement = (0, utils_1.$el)(ANNOUNCEMENT_SELECTOR, this).cloneNode(true);
        }
        const announcement = this.announcement.cloneNode(true);
        const link = (0, utils_1.$el)(LINE_LINK_SELECTOR, this);
        if (!announcement) {
            return;
        }
        const nodes = this.isWithFontMixed
            ? this.getFragmentWithMixedFont(blocksNumberToRender, announcement)
            : this.getFragment(blocksNumberToRender, announcement);
        if (link) {
            nodes.appendChild(link);
        }
        this.replaceChildren(nodes);
    };
    getFragment = (blocksNumberToRender, announcement) => {
        const fragment = document.createDocumentFragment();
        const announcements = [];
        for (let i = 0; i < blocksNumberToRender; i++) {
            const clonedAnnouncement = announcement.cloneNode(true);
            let newClass = ANIMATION_CLASS;
            if (this.isWithFontMixed && i % 2 === 0) {
                newClass += ` ${FONT_OUTLINE_CLASS}`;
            }
            clonedAnnouncement.classList.add(newClass);
            announcements.push(clonedAnnouncement);
        }
        fragment.replaceChildren(...announcements);
        return fragment;
    };
    getFragmentWithMixedFont = (blocksNumberToRender, announcement) => {
        const fragment = document.createDocumentFragment();
        const announcements = [];
        for (let i = 0; i < blocksNumberToRender - 1; i++) {
            const clonedAnnouncement1 = announcement.cloneNode(true);
            const clonedAnnouncement2 = announcement.cloneNode(true);
            const div = document.createElement('div');
            clonedAnnouncement1.classList.add(FONT_OUTLINE_CLASS);
            div.replaceChildren(clonedAnnouncement1, clonedAnnouncement2);
            div.classList.add(ANIMATION_CLASS);
            announcements.push(div);
        }
        fragment.replaceChildren(...announcements);
        return fragment;
    };
    handleResize = (0, debounce_1.debounce)(() => {
        const screenWidth = document.body.clientWidth;
        if (screenWidth > this.initialScreenWidth) {
            this.render();
        }
        this.setAttribute('data-is-rendered', 'true');
    }, 100);
    render = () => {
        const { screenWidth, announcementWidth } = this.getDimentions();
        const blocksNumberToRender = this.calcQuantityToRender(screenWidth, announcementWidth);
        this.renderNodes(blocksNumberToRender);
    };
}
exports.ScrollingTextLine = ScrollingTextLine;
